/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandWikipedia = createReactComponent("brand-wikipedia", "IconBrandWikipedia", [
  ["path", { d: "M3 4.984h2", key: "svg-0" }],
  ["path", { d: "M8 4.984h2.5", key: "svg-1" }],
  ["path", { d: "M14.5 4.984h2.5", key: "svg-2" }],
  ["path", { d: "M22 4.984h-2", key: "svg-3" }],
  ["path", { d: "M4 4.984l5.455 14.516l6.545 -14.516", key: "svg-4" }],
  ["path", { d: "M9 4.984l6 14.516l6 -14.516", key: "svg-5" }]
]);

export { IconBrandWikipedia as default };
//# sourceMappingURL=IconBrandWikipedia.js.map
